import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_Watching           from './Watching'
import lmx_Events             from './Events'

// Charts 
import lmx_localData          from '../primitives/localData'
import lmx_LocalValues        from './set_LocalValues'
import lmx_Preprocess         from './set_Preprocess'
import lmx_draw_Forms         from './draw_Forms'

import lmx_draw_Toolbar       from './draw_Toolbar'

import lmx_draw_Header        from './draw_Header'
import lmx_draw_Timeline      from './draw_Timeline'
import lmx_draw_Table         from './draw_Table'
import lmx_draw_Gantt         from './draw_Gantt'

import lmx_Popup              from './popup/Modal'
import lmx_Popup_WorkOrder    from './popup/WorkOrder'
import lmx_Popup_MenuItem     from './popup/MenuItem'
export default {
  
  mixins: [

    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Events,
    lmx_Watching,
    
    lmx_LocalValues,
    lmx_Preprocess,
    lmx_draw_Forms,
    
    lmx_draw_Toolbar,
    lmx_draw_Header,
    lmx_draw_Timeline,
    lmx_draw_Table,
    lmx_draw_Gantt,

    lmx_Popup,
    lmx_Popup_WorkOrder,
    lmx_Popup_MenuItem,
    
  ],

}
